import { jsx } from "react/jsx-runtime";
import CalculateIcon from "@mui/icons-material/Calculate";
import { validateTidalLicense } from "../../base/index.js";
function Calculate(props) {
  return /* @__PURE__ */ jsx(
    CalculateIcon,
    {
      "data-testid": "Calculate",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "Calculate",
      "data-tidal-icon-meta": "money,invoices,payments"
    }
  );
}
Calculate.tidalIconMeta = {
  categories: "money,invoices,payments",
  name: "Calculate"
};
validateTidalLicense();
export {
  Calculate
};
//# sourceMappingURL=Calculate.js.map
